import React from 'react';
import {
  Grid, TextField, Button, FormControlLabel, Checkbox,
} from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

// Add explicit module declaration
export interface TimelineFilterControlsProps {
  buildingId: string;
  setBuildingId: (id: string) => void;
  startDate: Date | null;
  setStartDate: (date: Date | null) => void;
  endDate: Date | null;
  setEndDate: (date: Date | null) => void;
  clampDates: boolean;
  setClampDates: (clamp: boolean) => void;
  fetchAPTUData: () => void;
  isLoading: boolean;
}

const TimelineFilterControls: React.FC<TimelineFilterControlsProps> = ({
  buildingId,
  setBuildingId,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  clampDates,
  setClampDates,
  fetchAPTUData,
  isLoading,
}) => {
  return (
    <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Building ID"
          value={buildingId}
          onChange={(e) => setBuildingId(e.target.value)}
          placeholder="Filter by building ID"
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Start Date"
            value={startDate}
            onChange={(newValue) => setStartDate(newValue)}
            renderInput={(params) => <TextField {...params} fullWidth />}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="End Date"
            value={endDate}
            onChange={(newValue) => setEndDate(newValue)}
            minDate={startDate || undefined}
            renderInput={(params) => <TextField {...params} fullWidth />}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Button
          variant="contained"
          onClick={fetchAPTUData}
          disabled={isLoading || !startDate || !endDate}
          fullWidth
          sx={{ height: '56px' }}
        >
          {isLoading ? "Loading..." : "Load Timeline"}
        </Button>
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={clampDates}
              onChange={(e) => setClampDates(e.target.checked)}
              color="primary"
            />
          }
          label="Clamp timeline entries to selected date range"
        />
      </Grid>
    </Grid>
  );
};

export default TimelineFilterControls;
